var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Environment } from '../../shared/environment/environment';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { ActivatedRoute } from '@angular/router';
import { PageNames } from '../../shared/page-names.enum';
import { takeUntil } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation/navigation.service';
import { NavigableComponent } from '../../model/navigable-component';
import { TrialModalManagerComponent } from '../../modals/trial-modals/trial-modal-manager/trial-modal-manager.component';
import { TrialUtils } from '../../shared/utils/trial/trial-utils';
import { LanguageService } from '../../services/language/language.service';
import { DateUtil } from '../../shared/utils/Date/date-util';
import { Emitter } from '../../shared/utils/emitter/emitter';
import { EmitterConstants } from '../../shared/emitter-constants';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var TrialPageComponent = /** @class */ (function (_super) {
    __extends(TrialPageComponent, _super);
    function TrialPageComponent(route, changeDetector, navigationService, languageService, stateService, analyticsService) {
        var _this = _super.call(this, navigationService) || this;
        _this.route = route;
        _this.changeDetector = changeDetector;
        _this.navigationService = navigationService;
        _this.languageService = languageService;
        _this.stateService = stateService;
        _this.analyticsService = analyticsService;
        _this.runningTrials = [];
        _this.componentName = PageNames.TRIALS_PAGE;
        _this.ownedPacks = [];
        return _this;
    }
    TrialPageComponent.prototype.ngOnInit = function () {
        this.navigationService.setCurrentPageComponent(PageNames.TRIALS_PAGE);
        this.getRunningTrial();
        this.subscribeToTrialActivation();
        this.analyticsService.onDetailPage([OmapiIdConstants.PLAY_SPORTS_TRIAL, OmapiIdConstants.PLAY_TRIAL, OmapiIdConstants.PLAY_MORE_TRIAL]);
    };
    TrialPageComponent.prototype.ngOnDestroy = function () {
        this.navigationService.clearNavigation();
    };
    TrialPageComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.changeDetector.detectChanges();
        this.navigationService.registerPageElement(this.trialContentElement);
    };
    TrialPageComponent.prototype.openTrialActivationModal = function (event) {
        Emitter.of(EmitterConstants.OPEN_INPUT_TRIAL_CODE_MODAL).emit(this.componentName);
    };
    TrialPageComponent.prototype.openFindTrialModal = function () {
        this.trialModal.showFindTrialModal(true);
    };
    TrialPageComponent.prototype.onBack = function () {
        this.trialModal.closeEventSubscriptions();
        this.navigationService.resetPage();
        this.navigationService.clearNavigation();
        this.routeOnBackPressed();
    };
    TrialPageComponent.prototype.routeOnBackPressed = function () {
        window.history.back();
    };
    Object.defineProperty(TrialPageComponent.prototype, "trialsVisual", {
        get: function () {
            return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + 'trials-visual.png';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrialPageComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + 'trials-intro.jpg';
        },
        enumerable: true,
        configurable: true
    });
    TrialPageComponent.prototype.baseUrl = function () {
        return Environment.environmentConfig().baseUrl;
    };
    TrialPageComponent.prototype.getLogoUrl = function (omapiId) {
        return TrialUtils.getLogoUrlForTrialOmapiId(omapiId);
    };
    TrialPageComponent.prototype.getRunningTrial = function () {
        var _this = this;
        var packs = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        packs.filter(function (pack) { return pack.isTrial && pack.subscribed || pack.isDayPass && pack.subscribed; }).forEach(function (pack) {
            _this.enrichRunningTrials(pack);
        });
        packs.filter(function (pack) { return pack.subscribed; }).forEach(function (pack) {
            _this.ownedPacks.push(pack);
        });
    };
    TrialPageComponent.prototype.subscribeToTrialActivation = function () {
        var _this = this;
        Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL)
            .pipe(takeUntil(this.stopSubscription)).subscribe(function (trial) {
            _this.mapAndPushToRunningTrials(trial);
        });
    };
    TrialPageComponent.prototype.mapAndPushToRunningTrials = function (trial) {
        var isConversion = !!this.ownedPacks.filter(function (pack) { return pack.omapiId === trial.parentOmapiId; }).pop();
        this.runningTrials.push({
            omapiId: trial.omapiId,
            isTrial: true,
            logoUrl: this.getLogoUrl(trial.omapiId),
            endDate: DateUtil.getlocaleDate(DateUtil.getTrialEndDate(trial), this.languageService.getCurrentLanguage()),
            futureProduct: isConversion ? trial.parentOmapiId : undefined,
            futureProductName: isConversion ? OmapiIdConstants.PRODUCT_NAME_MAP.get(trial.parentOmapiId + '') : undefined
        });
    };
    TrialPageComponent.prototype.enrichRunningTrials = function (pack) {
        var isNotPresentOnArray = !this.runningTrials.filter(function (trial) { return trial.omapiId === pack.omapiId; }).pop();
        if (isNotPresentOnArray) {
            this.runningTrials.push({
                omapiId: pack.omapiId,
                futureProduct: pack.futureProduct,
                futureProductName: OmapiIdConstants.PRODUCT_NAME_MAP.get(pack.futureProduct + ''),
                isDayPass: pack.isDayPass,
                isTrial: pack.isTrial,
                logoUrl: this.getLogoUrl(pack.omapiId),
                endDate: DateUtil.getlocaleDate(pack.endDate, this.languageService.getCurrentLanguage()),
                largeLogo: (pack.omapiId === OmapiIdConstants.PLAY_TRIAL) ? 'play-trial-logo' : ''
            });
        }
    };
    return TrialPageComponent;
}(NavigableComponent));
export { TrialPageComponent };
